import { render, staticRenderFns } from "./FileUploadTable.vue?vue&type=template&id=351bfba0&scoped=true&"
import script from "./FileUploadTable.vue?vue&type=script&lang=js&"
export * from "./FileUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./FileUploadTable.vue?vue&type=style&index=0&id=351bfba0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351bfba0",
  null
  
)

export default component.exports